import axios from "../utils/axios-interceptor";

export const getCodeSpecificationApi = async(payload) => {
  try {
    const res = await axios.post(`/code_specification/?repoURL=${payload.repoPath}`, {selected_model: payload.selected_model},  {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}